import ApiService from "@/services/api.service";

const state = {
  customers: [],
  customerProjects: [],
  customerContacts: [],
  customer: "",
};

const getters = {
  getCustomers(state) {
    return state.customers;
  },
  getCustomerContacts(state) {
    return state.customerContacts;
  },
};

const actions = {
  fetchCustomers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("getcustomers/", payload)
        .then(({ data }) => {
          commit("setCustomers", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
          reject(e);
        });
    });
  },
  fetchCustomer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("getcustomerbyid/", {
        id: payload,
      })
        .then(({ data }) => {
          commit("setCustomer", data);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
          reject(e);
        });
    });
  },
  fetchCustomerProjects({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("getprojects/", payload)
        .then(({ data }) => {
          commit("setCustomerProjects", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
          reject(e);
        });
    });
  },
  fetchCustomerContacts({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("getusers/", payload)
        .then(({ data }) => {
          commit("setCustomerContacts", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
          reject(e);
        });
    });
  },
};

const mutations = {
  setCustomers(state, payload) {
    state.customers = payload;
  },
  setCustomer(state, payload) {
    state.customer = payload;
  },
  setCustomerProjects(state, payload) {
    state.customerProjects = payload;
  },
  setCustomerContacts(state, payload) {
    state.customerContacts = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
